import styled from 'styled-components'
import { theme } from '../../../theme/theme'
const { sixth, sixthHover, fifth, first, firstHover, seventh } = theme
import { H1, H4, StyledLink, CustomAlertHeading } from '../styled'

export const Header = styled.div`
	display:flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;
	margin-bottom: 24px;
	color: ${sixth};
`

export const Body = styled.div`
	padding-block: 10px;
	text-align: center;
`

export const Logout = styled.div`
	position:absolute;
	top: 12px;
	right: 14px;
	cursor:pointer;
	font-size: 20px;
	color: ${sixth};
	transition: all 333ms ease;

	&:hover {
		color: ${sixthHover};
	}
`

export const NavRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 12px;
	margin: 20px auto 0;
`

export const NavPill = styled.button`
	border: 1px solid rgba(255,255,255,0.35);
	background: rgba(255,255,255,0.08);
	color: white;
	border-radius: 999px;
	padding: 10px 20px;
	font-size: 0.95rem;
	cursor: pointer;
	transition: all 250ms ease;
	min-width: 170px;

	&:hover {
		background: rgba(255,255,255,0.16);
		border-color: rgba(255,255,255,0.55);
	}
`

export const CtaCard = styled.div`
	margin-top: 8px;
	padding: 20px 12px;
	background: rgba(255,255,255,0.12);
	border: 1px solid rgba(255,255,255,0.22);
	border-radius: 24px;
	box-shadow: 0 28px 60px rgba(18, 18, 42, 0.18);
	text-align: center;
	width: 100%;
	max-width: 620px;
	margin-left: auto;
	margin-right: auto;

	@media (min-width: 677px){
		margin-top: 28px;
		padding: 32px 28px;
	}

`

export const CtaIcon = styled.div`
	width: 70px;
	height: 70px;
	margin: 0 auto 10px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.06) 100%);
	box-shadow: inset 0 0 0 1px rgba(255,255,255,0.18);
	font-size: 28px;
	color: white;

	@media (min-width: 767px) {
		margin: 0 auto 22px;
	}
`

export const CtaTitle = styled(H1)`
	font-size: 34px;
	line-height: 1.1;
	margin-bottom: 4px;

	@media (max-width: 767px) {
		font-size: 26px;
	}
`

export const CtaSubtitle = styled(H4)`
	font-weight: 400;
	color: rgba(255,255,255,0.85);
	margin-bottom: 20px;
	font-size: 17px;
	line-height: 1.6;

	@media (min-width: 767px){
		margin-bottom: 26px;
	}
`

export const StartButton = styled.div`
	margin: 0 auto;
	border: none;
	color: white;
	font-size: 1.05rem;
	font-weight: 600;
	border-radius: 999px;
	cursor: pointer;
	width: min(100%, 320px);

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 22px 48px rgba(133, 81, 255, 0.42);
	}

	&:disabled {
		opacity: 0.65;
		cursor: not-allowed;
	}
`


export const EstimateRow = styled.div`
	margin-top: 18px;
	display: flex;
	justify-content: center;
	gap: 10px;
	align-items: center;
	color: rgba(255,255,255,0.72);
	font-size: 0.95rem;
`

export const TimeIcon = styled.span`
	font-size: 1.1rem;
`